import {BaseOptions} from '../../../../dialog/options/base.options';

export class AddOrUpdateSettingsOptions extends BaseOptions {
  setting?: any;

  onInsertOrUpdateFinished() {
  }
}
